import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2),
  },
}));

const ShippmentDetailsChanges = ({ className, shippmentChanges, ...rest }) => {
  const classes = useStyles();
  const [selectedSmstextIds] = useState([]);

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardHeader title="História zmien" />
      <Divider />
      <CardContent>
        <PerfectScrollbar>
          <Box minWidth={1050}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Dátum a čas</TableCell>
                  <TableCell>Kto zmenil</TableCell>
                  <TableCell>Zmena</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {shippmentChanges.map((shippment) => (
                  <TableRow
                    hover
                    key={shippment.id}
                    selected={selectedSmstextIds.indexOf(shippment.id) !== -1}
                  >
                    <TableCell>
                      <Box alignItems="center" display="flex">
                        <Typography color="textPrimary" variant="body1">
                          {shippment.changed_at.toLocaleString("sk-SK")}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box alignItems="center" display="flex">
                        <Typography color="textPrimary" variant="body1">
                          {shippment.user_name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box alignItems="center" display="flex">
                        <Typography color="textPrimary" variant="body1">
                          {shippment.changed}
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  );
};

ShippmentDetailsChanges.propTypes = {
  className: PropTypes.string,
  shippmentChanges: PropTypes.array.isRequired,
};

export default ShippmentDetailsChanges;
